import { useRef, useState } from "react";
import type {
	LayoutChangeEvent,
	NativeScrollEvent,
	NativeSyntheticEvent,
} from "react-native";

export const useHasScrolledContent = () => {
	const [hasScrolledContent, setHasScrolledContent] = useState(false);
	const layoutHeightRef = useRef(0);
	const contentHeightRef = useRef(0);
	const scrollOffsetRef = useRef(0);

	const update = () => {
		const next =
			scrollOffsetRef.current + layoutHeightRef.current <
			contentHeightRef.current - 1;
		setHasScrolledContent((prev) => (prev === next ? prev : next));
	};

	const onScroll = (e: NativeSyntheticEvent<NativeScrollEvent>) => {
		scrollOffsetRef.current = e.nativeEvent.contentOffset.y;
		update();
	};

	const onLayout = (e: LayoutChangeEvent) => {
		layoutHeightRef.current = e.nativeEvent.layout.height;
		update();
	};

	const onContentSizeChange = (_w: number, h: number) => {
		contentHeightRef.current = h;
		update();
	};

	return { hasScrolledContent, onScroll, onLayout, onContentSizeChange };
};
